import React from 'react'

function BuronBanMain() {
  return (
    <div>BuronBanMain</div>
  )
}

export default BuronBanMain